import { VehicleReservationsStatisticModel } from './../../../models/Common/VehicleReservationsStatisticModel';
import { CommonService } from './../../../services/common.service';
import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { faBars, faCar, faExchangeAlt, faRestroom, faCog } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'counters',
  templateUrl: './counters.component.html',
  styleUrls: ['./counters.component.css']
})
export class CountersComponent implements OnInit {

  faBars= faBars;
  faCar= faCar;
  faExchangeAlt= faExchangeAlt;
  faRestroom= faRestroom;
  faCog= faCog;
  statistic:VehicleReservationsStatisticModel;
  listener;
  statisticDivYPosition;
  @ViewChild('statisticDiv', { static: true }) statisticDiv: ElementRef;




  @HostListener("window:scroll", []) onWindowScroll() {
    // do some stuff here when the window is scrolled
    const verticalOffset = window.pageYOffset
          || document.documentElement.scrollTop
          || document.body.scrollTop || 0;

          if(verticalOffset+200>=this.statisticDivYPosition){
            if(this.statistic==null){
              this.commonService.getVehicleReservationsStatistic().subscribe(res =>{
                this.statistic=res;
              })
            }
          }
}
  constructor(private commonService:CommonService,private renderer2: Renderer2) {

    /* this.listener = this.renderer2.listen('window', 'scroll', (e) => {

      if(this.getYPosition(e)+100>=this.statisticDivYPosition){
        if(this.statistic==null){
          this.commonService.getVehicleReservationsStatistic().subscribe(res =>{
            this.statistic=res;
          })
        }
      }

    }); */
   }

  ngOnInit(): void {
    this.statisticDivYPosition=this.statisticDiv.nativeElement.getBoundingClientRect().y;

  }

 getYPosition(e: Event): number {
  let x=(e.target as Element);

    return (e.target as Element).scrollTop ;
  }

  ngOnDestroy(): void {
    //this.listener();
}


}
